<script lang="ts">
    import {onMount} from "svelte";
    import {MouseEnterTipsViewUtil} from "../../../component/common/Information/MouseEnterTipsViewUtil";

    export let space;

    onMount(() => {
    });


</script>

<div class="space-authority-sign-view">
    {#if space.is_public === 1}
        <span class="public-sign"
              on:mouseenter={(event)=>{
                  MouseEnterTipsViewUtil.show(event, "このスペースは社員、派遣社員、業務委託含め、ログインできた人全員がアクセスできます");
              }}
        >グループ全体公開</span>
    {:else}
           <span class="private-sign"
                 on:mouseenter={(event)=>{
                  MouseEnterTipsViewUtil.show(event, "このスペースは限られた人だけアクセスが可能です");
              }}
           >Private</span>
    {/if}

    {#if space.can_employee_only === 1}
         <span class="employee-sign"
               on:mouseenter={(event)=>{
                  MouseEnterTipsViewUtil.show(event, "社員のみアクセス可能。派遣、業務委託は閲覧できません");
              }}
         >社員限定</span>
    {/if}


</div>
<style lang="scss">
    .space-authority-sign-view {
        font-size: 10px;
        user-select: none;

        .public-sign {
            background-color: var(--bana-orange-color);
            color: var(--bana-white-color);
            padding-left: 0.5em;
            padding-right: 0.5em;
            border-radius: 1em;
            user-select: none;
        }

        .employee-sign {
            color: var(--info-color);
            border-style: solid;
            border-width: 1px;
            border-color: var(--info-color);
            padding-left: 0.5em;
            padding-right: 0.5em;
            border-radius: 0em;
            user-select: none;
        }

        .private-sign {
            border-style: solid;
            border-width: 1px;
            border-color: #0003;
            padding-left: 0.5em;
            padding-right: 0.5em;
            border-radius: 1em;
            user-select: none;
        }
    }
</style>